import React from 'react'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { StyledAiHighlightedText } from '../../../common/components/styled'

const DishIngredientsDrawerMenuText = ({
  menuText,
  highlight,
  isSuggestedUsingMl,
  isSuggestedUsingParser,
  mlScore,
}) => {
  if (isSuggestedUsingMl && !isSuggestedUsingParser) {
    return `ML suggested${
      !isNil(mlScore) ? ` (${parseFloat(mlScore).toFixed(2)})` : ''
    }`
  }

  if (isNil(menuText)) {
    return ''
  }

  return !isNil(highlight) ? (
    <StyledAiHighlightedText highlights={[highlight]}>
      {menuText}
    </StyledAiHighlightedText>
  ) : (
    menuText
  )
}

DishIngredientsDrawerMenuText.propTypes = {
  menuText: PropTypes.string.isRequired,
  highlight: PropTypes.string.isRequired,
  isSuggestedUsingMl: PropTypes.bool,
  isSuggestedUsingParser: PropTypes.bool,
  mlScore: PropTypes.number,
}

DishIngredientsDrawerMenuText.defaultProps = {
  isSuggestedUsingMl: false,
  isSuggestedUsingParser: false,
  mlScore: undefined,
}

export default DishIngredientsDrawerMenuText
